module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00170.4b64d086.jpg";